const sendReceive = 'send / receive';
const howItWorks = 'how it works';
const hireUs = 'hire us!';
const faqs = 'faqs';

export const labels = [sendReceive, howItWorks, faqs, hireUs];
